exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.about .about-detail {\n  padding: 0.466667rem 0.4rem;\n}\n.about .about-detail img {\n  width: 100%;\n  margin-bottom: 0.266667rem;\n}", ""]);

// exports
